export enum EmployeeExitType {
    Resignation = 'Resignation',
    Termination = 'Termination'
  }